import { post } from '@alltrails/shared/api';
import Coupon from 'types/Coupon';

// eslint-disable-next-line import/prefer-default-export
export async function verify(couponCode: string) {
  return post<Coupon[]>('/api/alltrails/coupons/verify', { coupon_code: couponCode });
}
